module.exports = __webpack_public_path__ + "static/media/01.408716c5.png";